/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Upfront_Date_Without_AmountInputs */

const en_case_payment_validation_upfront_date_without_amount = /** @type {(inputs: Case_Payment_Validation_Upfront_Date_Without_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the upfront date when there is no upfront amount.`)
};

const pt_br2_case_payment_validation_upfront_date_without_amount = /** @type {(inputs: Case_Payment_Validation_Upfront_Date_Without_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remova a data à vista quando não houver valor à vista.`)
};

/**
* | output |
* | --- |
* | "Remove the upfront date when there is no upfront amount." |
*
* @param {Case_Payment_Validation_Upfront_Date_Without_AmountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_upfront_date_without_amount = /** @type {((inputs?: Case_Payment_Validation_Upfront_Date_Without_AmountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Upfront_Date_Without_AmountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_upfront_date_without_amount(inputs)
	return pt_br2_case_payment_validation_upfront_date_without_amount(inputs)
});